import SoftBox from 'components/SoftBox'
import React, { useState } from 'react'
import TelsimStockHead from './Header'
import { getApiHeader } from 'utlis/commonfunctions';
import axios from 'axios';





const SERVER_URL = process.env.REACT_APP_API_URL;
function PidVerification() {
 const[disable,setDisable]=useState(false)
 const [continueButton,setContinueButton]=useState(false)
 const[formData,setFormData]=useState("")
 const[retailerDetails,setRetailerDetails]=useState()
 














 const handleChange= (event)=>{
  const{name,value}=event.target
  setFormData(value)
 }
  
 const handleContinue= ()=>{

 }

 const handleSearch= async(e)=>{
  e.preventDefault()
   const headers= await getApiHeader()
   const shop_code=formData
     try {
     const response= await axios.post(`${SERVER_URL}product-stock/search`,{shop_code},{headers})
     if(response.status==200){
      setContinueButton(true)
     }
       setRetailerDetails(response.data.data)
     } catch (error) {
       console.log("error in search===>",error)
     }
 }

  return (
    
    <div>
     <TelsimStockHead/>

      <div className="formbold-form-wrapper">
        <h3 style={{ textAlign: "center" }}>Search Retailer</h3>
        <form action="" method="" onSubmit={handleSearch}>
          <div className="formbold-mb-5 formbold-pt-3">
            <label className="formbold-form-label formbold-form-label-2">
            </label>
            <div className="flex flex-wrap formbold--mx-3 upload-form">
              <div className="w-full sm:w-half formbold-px-3 ">
                <div className="formbold-mb-5 add-plan-form input">
                  <label htmlFor="store_name" className="formbold-form-label">
                    Retailer Id <span class="astrix-color">*</span>
                  </label>
                  <input
                    type="text"
                    name="shop_code"
                    id="shop_code"
                    placeholder="Enter Retailer Id"
                    className="formbold-form-input  "
                    // value={formData.shop_code}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>


          {continueButton &&
            <div className="formbold-main-wrapper  ">
              <SoftBox component="form" role="form" style={{ width: "auto" }} mx={"5%"}>
                <SoftBox mb={2}>
                  <div className="recharge-details">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th style={{textAlign:'left', fontSize:'12px'}}>Dealer Name</th>
                        <td style={{textAlign:'left', fontSize:'12px'}}> {retailerDetails.retailer_name}</td>
                        </tr>
                        <tr>
                          <th style={{textAlign:'left', fontSize:'12px'}}>Company/Store Name</th>
                          <td style={{textAlign:'left', fontSize:'12px'}}> {retailerDetails.retailer_company_name}</td>
                        </tr>
                        <tr>
                          <th style={{textAlign:'left', fontSize:'12px'}}>Dealer Address</th>
                          <td style={{textAlign:'left', fontSize:'12px'}}> {retailerDetails.address}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </SoftBox>
              </SoftBox>
            </div>
          }



          <div className="search-store-buttons">
            {continueButton ?
              <button className="search-store-button" type="submit" onClick={handleContinue}>Continue <i class="fa fa-angle-double-right"></i></button>
              :
              <button className="search-store-button" type="submit"><i class="fa fa-search" disabled={disable} ></i> Search </button>
            }
          </div>
        </form>
      </div>
    </div>
  
  )
}

export default PidVerification